import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M12.833 8.667c-3.37.291-5.208 2.13-5.5 5.5-.304-3.422-2.133-5.119-5.5-5.5 3.42-.395 5.106-2.08 5.5-5.5.382 3.367 2.078 5.196 5.5 5.5"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M13.193.84a.195.195 0 0 0-.386-.001c-.074.638-.265 1.087-.573 1.395s-.757.5-1.395.573a.194.194 0 0 0 0 .386c.628.071 1.087.262 1.402.572.314.308.509.757.565 1.391a.194.194 0 0 0 .388 0c.054-.624.248-1.082.564-1.398s.774-.51 1.398-.564a.194.194 0 0 0 0-.388c-.634-.056-1.083-.25-1.391-.565-.31-.315-.5-.774-.572-1.402"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgNew;
